module.exports = __webpack_public_path__ + "static/919m-hero-a46b0c009b1fbc29839336cfb642070c.mp4";